import iziToast from 'izitoast'
import { formatFlowTerminology } from '@/shared/utils/flowTerminology'

/** Legacy colour API mapped onto the toast variants. */
export type MatrixNotifyColor = 'green' | 'red'

export interface MatrixNotify {
  success: (message: string, title?: string) => void
  error: (message: string, title?: string) => void
  info: (message: string, title?: string) => void
}

/**
 * Notify bridge — replaces the legacy global toast helper.
 * Ported call sites used a colour API (`'green'` success, `'red'` error); those
 * translate directly to `success()` / `error()` here.
 */
export function useMatrixNotify(): MatrixNotify {
  const settings = (
    message: string,
    title?: string,
  ): { message: string; title?: string } =>
    title === undefined
      ? { message: formatFlowTerminology(message) }
      : { message: formatFlowTerminology(message), title: formatFlowTerminology(title) }

  const success = (message: string, title?: string): void => {
    iziToast.success(settings(message, title))
  }

  const error = (message: string, title?: string): void => {
    iziToast.error(settings(message, title))
  }

  const info = (message: string, title?: string): void => {
    iziToast.info(settings(message, title))
  }

  return { success, error, info }
}
